/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Button, Container, Form, Image, Row } from "react-bootstrap";
import { CButton, CImage } from "@coreui/react";
import L from "leaflet";
import { debounce } from "lodash";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import Skeleton from "react-loading-skeleton";
import { BsArrowClockwise, BsBoxArrowUpRight } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { PiGpsFix } from "react-icons/pi";
import { StoreContext } from "../context/StoreContext";
import authservice from "../services/auth.services";
import { useBucket } from "../context/GetBucketDetailsContext";
import { useStoreStock } from "../context/StoreStockContext";
import "react-loading-skeleton/dist/skeleton.css";
import CaptchaModal from "../components/CaptchaModal";

const StoreMapPage = () => {
  const storeTypeMarkers = [
    {
      id: 1,
      storeTypeCode: "GS",
      url: "/images/grocery-marker.svg",
      pulseShadowColor: "#3b5cffa3",
    },
    {
      id: 2,
      storeTypeCode: "DS",
      url: "/images/dairy-marker.svg",
      pulseShadowColor: "#339f7e7a",
    },
    {
      id: 3,
      storeTypeCode: "FVS",
      url: "/images/fruits-veg-marker.svg",
      pulseShadowColor: "#cc840099",
    },
    {
      id: 4,
      storeTypeCode: "HS",
      url: "/images/health-marker.svg",
      pulseShadowColor: "#ba1c0082",
    },
    {
      id: 5,
      storeTypeCode: "OS",
      url: "/images/other-store-marker.svg",
      pulseShadowColor: "#42c46c9e",
    },
    {
      id: 6,
      storeTypeCode: "CS",
      url: "/images/confectionary-marker.svg",
      pulseShadowColor: "#f65e58ad",
    },
    {
      id: 7,
      storeTypeCode: "CSD",
      url: "/images/canteen-marker.svg",
      pulseShadowColor: "#666bdc7d",
    },
    {
      id: 8,
      storeTypeCode: "AS",
      url: "/images/apparel-marker.svg",
      pulseShadowColor: "#14104199",
    },
    {
      id: 9,
      storeTypeCode: "HDS",
      url: "/images/hardware-marker.svg",
      pulseShadowColor: "#1776ff87",
    },
    {
      id: 10,
      storeTypeCode: "IT",
      url: "/images/it-marker.svg",
      pulseShadowColor: "#2f9fcf",
    },
  ];
  const lastCenterRef = useRef(null);
  const suggestionsRef = useRef(null);
  const popupRefs = useRef({});
  const searchCache = useRef({});
  const userKey = localStorage.getItem("userKey");
  const rawLat = localStorage.getItem("selectedCityLat");
  const rawLng = localStorage.getItem("selectedCityLng");
  const lat = rawLat && !isNaN(parseFloat(rawLat)) ? parseFloat(rawLat) : null;
  const lng = rawLng && !isNaN(parseFloat(rawLng)) ? parseFloat(rawLng) : null;
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionPage, setSuggestionPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMoreSuggestions, setHasMoreSuggestions] = useState(false);
  const [currentLocation, setCurrentLocation] = useState({});
  const [vendorID, setVendorID] = useState("");
  const [visitStoreClicked, setVisitStoreClicked] = useState(false);
  const [selectedVariations, setSelectedVariations] = useState({});
  const {
    location,
    nearbyStores,
    setSelectedStore,
    storesLatLng,
    hasSearched,
    setHasSearched,
    selectedStoreID,
    setSelectedStoreID,
    scrollToMapSectionRef,
    cityLatLng,
    showSelect,
    setManuallyToggled,
    recenterCurLoc,
    setRecenterCurLoc,
    setStoresLatLng,
  } = useContext(StoreContext);
  const {
    getStoresDetails,
    setSortByPrice,
    setSortByDistance,
    setIsAvailable,
    storeStocksData,
    setViewMoreState,
  } = useStoreStock();
  const {
    addToBucket,
    removeBucketItem,
    bucketItems,
    loading: bucketLoading,
  } = useBucket();

  const addedItemsBar = useMemo(
    () =>
      (bucketItems || []).map((b) => ({
        bucketID: b.bucketID,
        productID: b.productID,
        productVariationID: b.productVariationID,
        name: b.productRes?.name,
        productVariationName:
          b.productRes?.productVariations?.[0]?.productVariationName,
      })),
    [bucketItems],
  );

  const getSuggestion = async (searchQuery, page) => {
    setIsLoading(true);
    if (page === 1 && searchCache.current[searchQuery]) {
      setSuggestions(searchCache.current[searchQuery]);
      setIsLoading(false);
      return;
    }

    const url = "getSuggestedProducts";
    const jsonData = {
      searchText: searchQuery,
      pageNo: page,
    };

    try {
      const response = await authservice.postJsonData(url, jsonData);

      if (
        response.apiResponseCode === "1001" &&
        Array.isArray(response.products)
      ) {
        setSuggestions((prev) =>
          page === 1 ? response.products : [...prev, ...response.products],
        );
        searchCache.current[searchQuery] = response.products;

        const initialSelections = {};
        response.products.forEach((product) => {
          if (
            Array.isArray(product.productVariations) &&
            product.productVariations.length > 0
          ) {
            initialSelections[product.productID] = 0;
          }
        });
        setSelectedVariations((prev) => ({ ...prev, ...initialSelections }));
        const totalFetched =
          (page - 1) * response.pageLimit + response.products.length;
        setHasMoreSuggestions(totalFetched < response.totalRecords);
      } else {
        setSuggestions([]);
        setIsLoading(false);
        setHasMoreSuggestions(false);
      }
    } catch (error) {
      console.warn("Suggestion fetch error:", error);
      setSuggestions([]);
      setHasMoreSuggestions(false);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedGetSuggestion = useRef(
    debounce((text) => {
      setSuggestionPage(1);
      getSuggestion(text, 1);
    }, 1000),
  ).current;

  const setBucketProduct = async (value) => {
    const productId = value.productID;
    const selectedIndex = selectedVariations[productId] || 0;
    const selectedVariation = value.productVariations?.[selectedIndex] || {};

    try {
      const itemData = {
        bucketID: null,
        productID: productId,
        productVariationID: selectedVariation.productVariationID,
        userKey,
        description: value?.description,
      };
      await addToBucket(itemData);
    } catch (error) {
      console.warn("Basket set error:", error);
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchText(value);
    setIsLoading(true);
  };

  const clickSearchAll = async () => {
    setSortByPrice("");
    setSortByDistance("");
    setIsAvailable("");
    setSearchText("");
    setSelectedStore({ name: "All Stores", storeTypeID: "" });
    setViewMoreState({});
    if (addedItemsBar?.length > 0) {
      await getStoresDetails();
      setHasSearched(true);
    }
  };

  const clickProductSearch = async (e, suggestion) => {
    e.stopPropagation();
    setHasSearched(true);
    await setBucketProduct(suggestion);
    setSearchText("");
    await getStoresDetails();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const removeAddedItem = async (bucketID) => {
    try {
      await removeBucketItem(bucketID);
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };

  const getDistanceInMeters = (lat1, lng1, lat2, lng2) => {
    const toRad = (val) => (val * Math.PI) / 180;
    const R = 6371000; // Earth's radius in meters
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const FlyToCity = ({ latt, lngg, delay = 500 }) => {
    const map = useMap();
    const timeoutRef = useRef(null);
    const THRESHOLD = 100; // meters
    useEffect(() => {
      if (!map || !latt || !lngg) return;
      const currentCenter = map.getCenter();
      const distance = getDistanceInMeters(
        currentCenter.lat,
        currentCenter.lng,
        latt,
        lngg,
      );
      lastCenterRef.current = { lat: latt, lng: lngg };
      if (distance > THRESHOLD) {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          map.flyTo([latt, lngg], 15, {
            duration: 1.5,
            animate: true,
          });
        }, delay);
      }
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }, [latt, lngg, map, delay]);
    return null;
  };

  const FitBoundsHandler = ({
    markers,
    defaultLat,
    defaultLng,
    rawLat,
    rawLng,
  }) => {
    const map = useMap();

    useEffect(() => {
      if (!map) return;
      const points = [
        ...(markers
          ?.filter((m) => m?.latitude && m?.longitude)
          .map((m) => [m.latitude, m.longitude]) || []),
      ];

      // Include rawLat/rawLng if provided
      if (!isNaN(rawLat) && !isNaN(rawLng)) {
        points.push([rawLat, rawLng]);
      }

      if (points.length > 0) {
        const bounds = L.latLngBounds(points);
        if (bounds.isValid()) {
          map.fitBounds(bounds, {
            padding: [50, 50],
            maxZoom: 18,
            animate: true,
          });
        }
      } else if (!isNaN(defaultLat) && !isNaN(defaultLng)) {
        map.flyTo([defaultLat, defaultLng], 12, { animate: true });
      }
    }, [map, markers, defaultLat, defaultLng, rawLat, rawLng]);

    return null;
  };

  const addedVariationKeys = useMemo(() => {
    const keys = new Set();
    (bucketItems || []).forEach((item) => {
      keys.add(`${item.productID}-${item.productVariationID}`);
    });
    return keys;
  }, [bucketItems]);

  const mapCenter = useMemo(() => {
    if (lat != null && lng != null) {
      return [lat, lng];
    }
    if (location?.latitude != null && location?.longitude != null) {
      return [location.latitude, location.longitude];
    }

    return null;
  }, [lat, lng, location]);

  // Group stores by lat-lng to detect duplicates
  const getAdjustedPosition = (store, index, groupedStores) => {
    const overlapCount =
      groupedStores[`${store.latitude}-${store.longitude}`]?.length || 1;
    if (overlapCount === 1) return [store.latitude, store.longitude];

    const offset = 0.00001 * index;
    return [store.latitude + offset, store.longitude + offset];
  };

  const groupedStoreCoords = useMemo(() => {
    const map = {};
    const stores =
      (hasSearched
        ? storeStocksData.map((s) => s.storeDetails)
        : nearbyStores) || [];

    stores.forEach((store) => {
      const key = `${store.latitude}-${store.longitude}`;
      if (!map[key]) map[key] = [];
      map[key].push(store);
    });

    return map;
  }, [hasSearched, storeStocksData, nearbyStores]);

  const navigateOnStore = (vendorId) => {
    setVisitStoreClicked(true);
    setVendorID(vendorId);
  };

  const centerCurrentLocMark = (rawLat, rawLng) => {
    if (rawLat && rawLng) {
      setCurrentLocation({ rawLat, rawLng });
      setSelectedStoreID(null); // reset slected store on current location navigation
      setStoresLatLng({ lat: null, lng: null }); // reseting store lat long
    }
  };

  useEffect(() => {
    if (searchText.length > 2) {
      setSuggestionPage(1);
      debouncedGetSuggestion(searchText);
    } else {
      debouncedGetSuggestion.cancel();
      setSuggestions([]);
      setIsLoading(false);
      setHasMoreSuggestions(false);
    }
  }, [searchText, debouncedGetSuggestion]);

  useEffect(() => {
    return () => {
      debouncedGetSuggestion.cancel();
    };
  }, []);

  useEffect(() => {
    if (!selectedStoreID) return;

    const tryOpenPopup = () => {
      const popup = popupRefs.current[selectedStoreID];
      if (popup && popup._source && popup._source.openPopup) {
        popup._source.openPopup();
      }
    };

    const timeoutId = setTimeout(tryOpenPopup, 100);
    return () => clearTimeout(timeoutId);
  }, [selectedStoreID]);

  useEffect(() => {
    if (addedItemsBar?.length === 0) {
      setHasSearched(false);
    }
  }, [addedItemsBar]);

  return (
    <Container fluid>
      <CaptchaModal
        visitStoreClicked={visitStoreClicked}
        setVisitStoreClicked={setVisitStoreClicked}
        vendorID={vendorID}
      />
      <Row>
        <div className="ezy-buy-map-area" ref={scrollToMapSectionRef}>
          <div style={{ height: "450px", width: "100%" }}>
            <span
              className="gps-icon-location"
              onClick={() => {
                centerCurrentLocMark(rawLat, rawLng);
                setRecenterCurLoc(true);
                // close slected store marker popup
                Object.values(popupRefs.current).forEach((popupRef) => {
                  try {
                    popupRef?._source?.closePopup?.();
                  } catch (e) {
                    console.warn("Failed to close popup:", e);
                  }
                });
                popupRefs.current = {};
                // add null lastCenterRef preveious selcetd store lat long
                if (lastCenterRef?.current) {
                  lastCenterRef.current = null;
                }
              }}
            >
              <PiGpsFix size={30} />
            </span>

            {mapCenter ? (
              <MapContainer
                center={mapCenter}
                zoom={15}
                minZoom={12}
                maxZoom={18}
                scrollWheelZoom={false}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {storesLatLng?.lat != null && storesLatLng?.lng != null ? (
                  <FlyToCity latt={storesLatLng.lat} lngg={storesLatLng.lng} />
                ) : cityLatLng.lat != null && cityLatLng.lng != null ? (
                  hasSearched ? (
                    <FitBoundsHandler
                      markers={storeStocksData.map((s) => s.storeDetails)}
                      defaultLat={cityLatLng.lat}
                      defaultLng={cityLatLng.lng}
                      rawLat={rawLat}
                      rawLng={rawLng}
                    />
                  ) : (
                    <FlyToCity
                      latt={cityLatLng.lat}
                      lngg={cityLatLng.lng}
                      delay={500}
                    />
                  )
                ) : null}
                {(hasSearched ? storeStocksData : nearbyStores)?.map((el) => {
                  const store = hasSearched ? el.storeDetails : el;
                  if (!store?.latitude || !store?.longitude) return null;

                  const matchedMarker = storeTypeMarkers.find(
                    (marker) => marker?.storeTypeCode === store?.storeTypeCode,
                  );
                  const markerIconUrl = matchedMarker?.url;
                  const pulseShadowColor = matchedMarker?.pulseShadowColor;

                  // Adjust position for duplicate lat/lng markers
                  const duplicateGroup =
                    groupedStoreCoords[
                      `${store.latitude}-${store.longitude}`
                    ] || [];
                  const adjustedPosition = getAdjustedPosition(
                    store,
                    duplicateGroup.indexOf(store),
                    groupedStoreCoords,
                  );

                  return (
                    <Marker
                      className="map-marker"
                      key={store?.storeID}
                      position={adjustedPosition}
                      icon={L.divIcon({
                        html: `<div class="pulse-shadow-icon" style="--pulse-color: ${pulseShadowColor}">
                <img src="${markerIconUrl}" style="width: 50px; height: 50px;" />
              </div>`,
                        className: "",
                        iconSize: [50, 50],
                        iconAnchor: [25, 50],
                        popupAnchor: [0, -50],
                      })}
                      zIndexOffset={
                        selectedStoreID === store.storeID ? 1000 : 0
                      }
                    >
                      <Popup
                        autoPan={false}
                        className="map-marker-popup"
                        ref={(ref) => {
                          if (ref && store?.storeID) {
                            popupRefs.current[store.storeID] = ref;
                          }
                        }}
                      >
                        <div className="map-marker-popup">
                          <div className="map-marker-popup-detail">
                            <p>
                              <strong>BusinessName:</strong>{" "}
                              {store?.businessName}
                            </p>
                            <p>
                              <strong>Store Type:</strong>{" "}
                              {store?.storeTypeName}
                            </p>
                            <p>
                              <strong>Mobile:</strong> {store?.mobileNo}
                            </p>
                            <p>
                              <strong>Address:</strong> {store?.address}
                            </p>
                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Distance:</strong>{" "}
                                {store?.estimatedDistanceKm?.toFixed(2)} km
                              </p>{" "}
                              <button
                                className="popup-visit-store-btn"
                                type="button"
                                onClick={() => navigateOnStore(store?.vendorID)}
                                // onClick={() =>
                                //   navigateOnStore(
                                //     el?.webUrl || el?.storeDetails?.webUrl,
                                //   )
                                // }
                              >
                                <BsBoxArrowUpRight />
                              </button>{" "}
                            </div>
                          </div>
                        </div>
                      </Popup>
                    </Marker>
                  );
                })}

                {/* current location marker */}
                {rawLat && rawLng && (
                  <Marker
                    position={[rawLat, rawLng]}
                    icon={L.divIcon({
                      html: `<div class="pulse-shadow-icon" style="--pulse-color: #00000055"><img src="/images/current-location.png" alt="location" style="width: 50px; height: 50px;" /></div>`,
                      className: "",
                      iconSize: [50, 50],
                      iconAnchor: [25, 50],
                      popupAnchor: [0, -50],
                    })}
                  />
                )}

                {recenterCurLoc &&
                  currentLocation?.rawLat &&
                  currentLocation?.rawLng && (
                    <FlyToCity
                      latt={currentLocation?.rawLat}
                      lngg={currentLocation?.rawLng}
                      delay={500}
                    />
                  )}
              </MapContainer>
            ) : (
              <p style={{ paddingTop: "5rem" }}>Loading map...</p>
            )}

            {addedItemsBar?.length > 0 && (
              <div className="map-fixed-area-status">
                {addedItemsBar.map((item) => (
                  <div
                    key={`${item?.productID}-${item?.productVariationID}`}
                    className="map-fixed-area-status-data"
                  >
                    <article>
                      <span className="product-name">{item?.name}</span>
                      <span className="product-variation">
                        {item?.productVariationName}
                      </span>
                    </article>
                    <Button
                      onClick={() =>
                        removeAddedItem(
                          item?.bucketID,
                          item?.productVariationID,
                        )
                      }
                      style={{
                        border: "none",
                        background: "transparent",
                        fontSize: "16px",
                        cursor: "pointer",
                        color: "red",
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div
            className={`form-group-search ${showSelect ? "show" : ""}`}
            ref={suggestionsRef}
          >
            <Form>
              {showSelect && (
                <Form.Group
                  className="search-products-bar hidex"
                  controlId="exampleForm.ControlInput1"
                >
                  <div className="wrap-button-content">
                    <CImage src="/images/product.svg" />
                  </div>

                  <input
                    type="text"
                    placeholder="Search By Product Name"
                    value={searchText}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyDown}
                    autoComplete="off"
                    className="search-box"
                  />

                  <div className="ezy-heading-value">
                    <button
                      className="remove-search-button"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSearchText("");
                        setManuallyToggled(false);
                      }}
                    >
                      {searchText?.length > 0 && <RxCross2 size={15} />}
                    </button>
                  </div>

                  <Button
                    className="bg-green br-green search-btn"
                    onClick={clickSearchAll}
                  >
                    {addedItemsBar.length < 1 ? (
                      <span>Search</span>
                    ) : (
                      <span>Search All ({addedItemsBar?.length})</span>
                    )}
                  </Button>

                  {/* Suggestions Dropdown */}
                  {searchText?.length > 2 && (
                    <div className="suggestions-dropdown">
                      <div className="ezy-scroller">
                        {isLoading ? (
                          <>
                            {[...Array(4)].map((_, index) => (
                              <div
                                key={index}
                                className="suggestion-item suggestion-main-wrapper"
                              >
                                <div
                                  className="suggestion-first-left"
                                  style={{ display: "flex" }}
                                >
                                  <div
                                    className="suggestion-img-box"
                                    style={{
                                      marginRight: "10px",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Skeleton height={60} width={60} />
                                  </div>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <Skeleton
                                      height={20}
                                      width="80%"
                                      style={{ marginBottom: 6 }}
                                    />
                                    <Skeleton
                                      height={16}
                                      width="60%"
                                      style={{ marginBottom: 4 }}
                                    />
                                    <Skeleton
                                      height={16}
                                      width="40%"
                                      style={{ marginBottom: 4 }}
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        marginTop: 6,
                                      }}
                                    >
                                      {[...Array(3)].map((_, i) => (
                                        <Skeleton
                                          key={i}
                                          width={60}
                                          height={24}
                                          borderRadius={4}
                                        />
                                      ))}
                                    </div>
                                  </div>
                                </div>
                                <span className="suggestion-button-action">
                                  <Skeleton
                                    height={35}
                                    width={130}
                                    borderRadius={4}
                                  />
                                </span>
                              </div>
                            ))}
                          </>
                        ) : suggestions.length > 0 ? (
                          <>
                            {suggestions.map((suggestion, index) => {
                              return (
                                <div
                                  key={suggestion?.productID || index}
                                  className="suggestion-item suggestion-main-wrapper"
                                >
                                  <div className="suggestion-first-left">
                                    {/* Product Image */}
                                    <div
                                      className="suggestion-img-box"
                                      style={{
                                        marginRight: "10px",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <Image
                                        src={
                                          suggestion?.imageUrl ||
                                          "/images/product-image.png"
                                        }
                                        alt={suggestion?.name}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "/images/product-image.png";
                                        }}
                                      />
                                    </div>
                                    <div
                                      style={{ flex: 1, minWidth: 0 }}
                                      className="suggestion-product-detail-varients"
                                    >
                                      <div className="sug-product-title">
                                        {suggestion?.name}
                                      </div>
                                      {suggestion?.category && (
                                        <div className="sug-product-category mt-7">
                                          Category:{" "}
                                          {suggestion?.category?.categoryName}
                                        </div>
                                      )}
                                      {suggestion.productBrand && (
                                        <div className="sug-product-brand mt-7">
                                          Brand:{" "}
                                          {suggestion.productBrand.brandName}
                                        </div>
                                      )}
                                      {Array.isArray(
                                        suggestion.productVariations,
                                      ) &&
                                        suggestion.productVariations.length >
                                          0 && (
                                          <div className="sug-product-varient mt-7">
                                            <div
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              {suggestion.productVariations.map(
                                                (v, i) => {
                                                  const isSelected =
                                                    selectedVariations[
                                                      suggestion.productID
                                                    ] === i;

                                                  return (
                                                    <span
                                                      key={
                                                        v.productVariationID ||
                                                        i
                                                      }
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedVariations(
                                                          (prev) => ({
                                                            ...prev,
                                                            [suggestion.productID]:
                                                              i,
                                                          }),
                                                        );
                                                      }}
                                                      role="button"
                                                      tabIndex={0}
                                                      onKeyDown={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      style={{
                                                        display: "inline-block",
                                                        background: isSelected
                                                          ? "#D8B90B"
                                                          : "#eee",
                                                        color: isSelected
                                                          ? "#000"
                                                          : "#333",
                                                        fontSize: "14px",
                                                        padding: "4px 8px",
                                                        borderRadius: "4px",
                                                        marginRight: "6px",
                                                        marginBottom: "4px",
                                                        cursor: "pointer",
                                                        border: isSelected
                                                          ? "1px solid #D8B90B"
                                                          : "1px solid #ccc",
                                                        transition:
                                                          "all 0.2s ease",
                                                        whiteSpace: "nowrap",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      {v.productVariationName}
                                                    </span>
                                                  );
                                                },
                                              )}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                  <span className="suggestion-button-action">
                                    <Button
                                      className="bg-green br-green search-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setBucketProduct(suggestion);
                                        setSearchText("");
                                        bucketLoading;
                                      }}
                                      disabled={addedVariationKeys.has(
                                        `${suggestion.productID}-${suggestion.productVariations?.[selectedVariations[suggestion.productID] || 0]?.productVariationID}`,
                                      )}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="19"
                                        viewBox="0 0 19 19"
                                        fill="none"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M5.44074 1C5.72074 0.41 6.32474 0 7.02274 0H11.0227C11.7207 0 12.3237 0.41 12.6047 1C13.2877 1.006 13.8207 1.037 14.2967 1.223C14.865 1.44527 15.3591 1.82301 15.7227 2.313C16.0897 2.807 16.2627 3.44 16.4987 4.311L17.2407 7.033L17.5207 7.874L17.5447 7.904C18.4457 9.058 18.0167 10.774 17.1587 14.205C16.6127 16.388 16.3407 17.479 15.5267 18.115C14.7127 18.75 13.5877 18.75 11.3377 18.75H6.70774C4.45774 18.75 3.33274 18.75 2.51874 18.115C1.70474 17.479 1.43174 16.388 0.886738 14.205C0.0287378 10.774 -0.400262 9.058 0.500738 7.904L0.524738 7.874L0.804738 7.033L1.54674 4.311C1.78374 3.44 1.95674 2.806 2.32274 2.312C2.68647 1.82238 3.18063 1.445 3.74874 1.223C4.22474 1.037 4.75674 1.005 5.44074 1ZM5.44274 2.503C4.78074 2.51 4.51474 2.535 4.29474 2.621C3.9887 2.74068 3.72255 2.94411 3.52674 3.208C3.35074 3.445 3.24674 3.776 2.95674 4.843L2.38674 6.932C3.40674 6.75 4.80074 6.75 6.70674 6.75H11.3377C13.2447 6.75 14.6377 6.75 15.6577 6.93L15.0887 4.841C14.7987 3.774 14.6947 3.443 14.5187 3.206C14.3229 2.94211 14.0568 2.73868 13.7507 2.619C13.5307 2.533 13.2647 2.508 12.6027 2.501C12.4608 2.79985 12.237 3.05232 11.9573 3.22914C11.6776 3.40596 11.3536 3.49987 11.0227 3.5H7.02274C6.69198 3.49996 6.36801 3.4062 6.08837 3.22956C5.80873 3.05293 5.58487 2.80166 5.44274 2.503Z"
                                          fill="#fff"
                                        />
                                      </svg>{" "}
                                      Add to Basket
                                    </Button>
                                    {addedItemsBar.length == 0 && (
                                      <p>
                                        <Button
                                          className="product-search-btn"
                                          onClick={(e) =>
                                            clickProductSearch(e, suggestion)
                                          }
                                        >
                                          Product Search
                                        </Button>
                                      </p>
                                    )}
                                  </span>
                                </div>
                              );
                            })}
                            {hasMoreSuggestions && (
                              <div className="d-f a-c j-center">
                                <CButton
                                  className="load-more-btn pa-block pa-inline"
                                  onClick={() => {
                                    const nextPage = suggestionPage + 1;
                                    setSuggestionPage(nextPage);
                                    getSuggestion(searchText, nextPage);
                                  }}
                                >
                                  Load More
                                  <BsArrowClockwise color="white" />
                                </CButton>
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            style={{
                              padding: "10px",
                              textAlign: "center",
                              color: "#666",
                            }}
                          >
                            No suggestions found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </Form.Group>
              )}
            </Form>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default StoreMapPage;
